import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100 mt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 font-heading font-bold">
                瓜
              </span>
              <span className="font-heading text-lg font-bold">独家吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90 font-label">
              把分散各处的娱乐快讯、现场直击与今日最新动态汇总到一处，随时刷新随时有料。
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 text-sm font-label text-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              爆料投稿与合作
            </Link>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <a href="/news" className="hover:text-accent-400 transition-colors">
                内容分类
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200/90 font-label">
              <li>
                <Link to="/category/hot-gossip" className="hover:text-accent-400 transition-colors">
                  明星八卦
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="hover:text-accent-400 transition-colors">
                  综艺爆料
                </Link>
              </li>
              <li>
                <Link to="/category/screen" className="hover:text-accent-400 transition-colors">
                  影视动态
                </Link>
              </li>
              <li>
                <Link to="/category/influencer" className="hover:text-accent-400 transition-colors">
                  网红热榜
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <a href="/about" className="hover:text-accent-400 transition-colors">
                关于本站
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200/90 font-label">
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-400 transition-colors">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/news" className="hover:text-accent-400 transition-colors">
                  全部快讯
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-accent-400 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">
              <a href="/contact" className="hover:text-accent-400 transition-colors">
                联系与投稿
              </a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200/90 font-label">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                contact@dujiaguacchi.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                快讯更新：工作日 07:00 - 23:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/70 font-label">
          <p>© {year} 独家吃瓜 · 本站内容仅作资讯整理，相关表述以官方信息为准。</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-accent-400 transition-colors">
              内容原则
            </Link>
            <Link to="/contact" className="hover:text-accent-400 transition-colors">
              联系反馈
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}